import { CapacitorSQLite, SQLiteConnection } from "@capacitor-community/sqlite";
import { Capacitor } from "@capacitor/core";

export const getSqliteConn = (() => {
  let instance: SQLiteConnection | null = null;
  return () => {
    if (!instance && Capacitor.isNativePlatform() && CapacitorSQLite) {
      instance = new SQLiteConnection(CapacitorSQLite);
    }
    return instance;
  };
})();
